import { Context } from 'chartjs-plugin-datalabels';

import { ICompanyWorkLife, IWorkLifeObj } from '~types/company';

import { PIE_CHART_LABELS_INFO } from '../../constants';

interface UseChartProps {
  externalTooltipHandler: (context: Context) => void;
  chartData?: IWorkLifeObj[];
}

export function useChartProps({ externalTooltipHandler, chartData }: UseChartProps) {
  if (!chartData) {
    return {};
  }

  const data = {
    labels: PIE_CHART_LABELS_INFO.map((obj) => obj.label),
    radius: 60,
    datasets: [
      {
        data: chartData,
        backgroundColor: PIE_CHART_LABELS_INFO.map((obj) => obj.backgroundColor),
        hoverBackgroundColor: PIE_CHART_LABELS_INFO.map((obj) => obj.backgroundColor),
      },
    ],
  };

  const options = {
    borderWidth: 1,
    parsing: {
      key: 'count',
    },
    plugins: {
      tooltip: {
        enabled: false,
        external: externalTooltipHandler,
      },
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
      },
    },
  };

  return { data, options };
}
